// When consuming tickets app from an iframe other than robin dashboard(i.e. the outlook extension app),
// the parent may need to give us the auth token and we cannot rely on the cookie since some
// auth flows may not set it for us
export const isUsingParentToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const useParentTokenParam = urlParams.get('use_parent_token') === 'true';
  return useParentTokenParam;
};
